import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { resetPasswordAction } from '../../redux/actions/authAction';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import successToast from '../../components/toast/successToast';
import errorToast from '../../components/toast/errorToast';
import logo from '../../assets/images/acumenVelocityLogo.svg';
import { Image, Spinner } from 'react-bootstrap';
import { passwordSchema, confirmPasswordSchema } from '../../utils/passwordValidation';
import PasswordStrengthMeter from '../../components/PasswordStrengthMeter';
/** Login using Email */
const ResetPassword = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    let { token } = useParams();
    const initialValues = {
        password: '',
        confirmPassword: '',
    }

    const onSuccess = (data) => {
        successToast(data.data.message);
        navigate('/email-login');
        setLoading(false);
    }

    const onError = (data) => {
        errorToast(data.data.message);
        setLoading(false);
    }

    const validationSchema = Yup.object().shape({
        password: passwordSchema,
        confirmPassword: confirmPasswordSchema,
    });

    const onSubmit = (values) => {
        const dispatchingValues = {
            resetToken: token,
            password: values.confirmPassword,
        }
        dispatch(resetPasswordAction(dispatchingValues, onSuccess, onError))
        setLoading(true)
    }


    return (
        <div className='w-100 d-flex flex-column align-items-center gap-4' style={{ minHeight: '100vh', backgroundColor: '#e9eef7' }}>
            <div className='d-flex gap-2 justify-content-start align-items-center cursor_pointer w-100' style={{ height: '4rem' }} onClick={() => navigate('/')}>
                <Image alt='logo' src={logo} height={40} className='mx-1' />
                <p className='name fs_16 fw_700'>Acumen Translation Hub</p>
            </div>
            <div className="d-flex justify-content-center align-items-center px-3 w-100" style={{ flex: 1 }}>
                <div className="border bg-white pb-4" style={{ width: '100%', maxWidth: '480px', borderRadius: 8 }}>
                    <div className="mt-2" style={{ width: '100%' }}>
                        <h5 className="card-title mb-4 text-nowrap mt-4">Reset Password</h5>
                        <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={onSubmit}
                        >
                            {({ values }) => (
                                <Form>

                                    <div className="text-start gap-3 mb-3 mx-4">
                                        <label htmlFor="password" className='py-1'>Password : </label>

                                        <Field name={"password"}>
                                            {({ field, meta }) => (
                                                <div className="position-relative">
                                                    <input
                                                        {...field}
                                                        placeholder="Enter your password"
                                                        id={"password"}
                                                        className={"input-field"}
                                                        style={{ width: '100%' }}
                                                        type={"password"}
                                                    />
                                                </div>
                                            )}
                                        </Field>
                                        <PasswordStrengthMeter password={values.password} />
                                        <div className='text-start text-danger text-wrap'>
                                            <ErrorMessage name="password">
                                                {(msg) => (
                                                    <>
                                                        <span
                                                            className={`ms-0 ms-lg-1  lh-sm fs_14 fw_600 fw-semibold text-wrap`}
                                                        >
                                                            {msg}
                                                        </span>
                                                    </>
                                                )}
                                            </ErrorMessage>
                                        </div>
                                    </div>
                                    <div className="text-start gap-3 mb-3 mx-4 mt-2">
                                        <label htmlFor="confirmPassword" className='py-1'>Confirm Password :</label>
                                        <Field name={"confirmPassword"}>
                                            {({ field, meta }) => (
                                                <div className="position-relative">
                                                    <input
                                                        {...field}
                                                        placeholder="Enter your password"
                                                        id={"confirmPassword"}
                                                        className={"input-field"}
                                                        style={{ width: '100%' }}
                                                        type={"password"}
                                                    />
                                                </div>
                                            )}
                                        </Field>
                                        <div className='text-start text-danger text-wrap'>
                                            <ErrorMessage name="confirmPassword">
                                                {(msg) => (
                                                    <>
                                                        <span
                                                            className={`ms-0 ms-lg-1  lh-sm fs_14 fw_600 fw-semibold`}
                                                        >
                                                            {msg}
                                                        </span>
                                                    </>
                                                )}
                                            </ErrorMessage>
                                        </div>
                                        {loading && <> <Spinner size='sm' className='text-primary' /> <span className='fs_14 fw_400'>Updating.....</span></>}
                                    </div>
                                    <div>
                                        <button type="submit" className="btn btn-primary" disabled={loading} >Submit</button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default ResetPassword;
